import React, { useState, useEffect } from 'react';

import { Modal } from 'antd';
import { useMedia } from 'react-media';

import { WithLoading } from 'common/components';

import ManageScheduleDownloadLayout from './ManageScheduleDownloadLayout';
import ManageScheduleDownloadToolbar from './ManageScheduleDownloadToolbar';
import ManageScheduleDownloadGrid from './ManageScheduleDownloadGrid';

const ManageScheduleDownloadModal = (props) => {
  const { visible, folderId, onCancel } = props;

  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const isSmallScreen = useMedia({ query: '(max-width: 1440px)' });

  const resetState = () => {
    setSelectedSchedule(null);
  };

  useEffect(() => {
    resetState();
  }, [visible]);

  return (
    <Modal
      visible={visible}
      title='Manage Schedule Download'
      width={1200}
      bodyStyle={{ height: 'min(600px, 80vh)' }}
      destroyOnClose
      maskClosable={false}
      centered={isSmallScreen}
      onCancel={onCancel}
      footer={null}
    >
      <WithLoading loading={false}>
        <ManageScheduleDownloadLayout>
          <ManageScheduleDownloadToolbar
            slot='toolbar'
            folderId={folderId}
            selectedSchedule={selectedSchedule}
            setSelectedSchedule={setSelectedSchedule}
          />
          <ManageScheduleDownloadGrid
            slot='grid'
            folderId={folderId}
            setSelectedSchedule={setSelectedSchedule}
          />
        </ManageScheduleDownloadLayout>
      </WithLoading>
    </Modal>
  );
};

export default ManageScheduleDownloadModal;
